import {useEffect} from "../../../__snowpack__/pkg/react.js";
export const useOnClickOutside = (ref, callback) => {
  useEffect(() => {
    function handler(event) {
      if (!ref.current?.contains(event.target)) {
        callback();
      }
    }
    window.addEventListener("click", handler);
    return () => window.removeEventListener("click", handler);
  }, [callback, ref]);
};
